import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from './traits';
import { colTableRef, fileListRef } from './consts';

export default grapesjs.plugins.add('gjs-child-data-group', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'child-data-group',
    pfxFile: 'child-data-group-file',
    blocks: [colTableRef, fileListRef],
    defaultStyle: true,
    labelTable: 'Child Data Group',
    labelFileDatagroup: 'Child Data Group (File)',
    labelCMSCategory: 'CMS',
    labelColName: 'Collection',
    labelFieldName: 'Collection Fields',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadTraits(editor, options);
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
